import { render, staticRenderFns } from "./WorkflowInvocationSummary.vue?vue&type=template&id=61ff4882&"
import script from "./WorkflowInvocationSummary.vue?vue&type=script&lang=js&"
export * from "./WorkflowInvocationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports